import client from './client';

export function getFullDuplexFeedback() {
  return client.get('/api/full-duplex-feedback');
}

export function saveFullDuplexFeedback(payload) {
  return client.put('/api/full-duplex-feedback/mine', payload);
}

export function updateFullDuplexTestState(payload) {
  return client.patch('/api/full-duplex-feedback/state', payload);
}

export function downloadFullDuplexInstruction(key) {
  return client.get(`/api/full-duplex-feedback/instructions/${encodeURIComponent(key)}`, {
    responseType: 'blob',
  });
}
